import React from 'react';
import { Outlet } from 'react-router-dom';
import NavbarContainer from 'src/js/modules/navbar/containers/navbar-container';
import CopyrightFooterContainer from 'src/js/modules/copyright-footer/containers/copyright-footer-container';

function PageContainer() {
  return (
    <div className="ws-page-container">
      <NavbarContainer />

      <main className="ws-page-content">
        <Outlet />
      </main>

      <CopyrightFooterContainer />
    </div>
  );
}

export default PageContainer;
